import { Avatar, AvatarFallback, AvatarImage } from "@radix-ui/react-avatar";
import { Card, CardContent } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { KeyRound, LogOut, Shield } from "lucide-react";
import { useNavigate } from "react-router-dom";
import auth from "@/shared/api/auth";

export const ProfileHeader = ({ user }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await auth.logout();
      localStorage.removeItem("access_token");
      navigate("/auth");
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleAdminPanel = async () => {
    try {
      navigate("/admin");
    } catch (err) {
      console.error(err.message);
    }
  };

  const handleChangePassword = async () => {
    try {
      navigate("/profile/change-password");
    } catch (err) {
      console.error(err.message);
    }
  };

  return (
    <Card className="mb-8 w-full">
      <CardContent className="pt-6">
        <div className="flex flex-col lg:flex-row items-start md:items-start gap-6">
          {/* Аватар и имя */}
          <div className="flex items-center gap-4">
            <Avatar className="w-20 h-20">
              <AvatarImage
                className="rounded-full"
                src={user.avatar}
                alt={user.name}
              />
              <AvatarFallback className="bg-primary w-20 h-20 rounded-full grid place-items-center text-4xl text-bold text-white">
                {user.name.charAt(0).toUpperCase()}
              </AvatarFallback>
            </Avatar>
            <div>
              <h3 className="my-1">{user.name}</h3>
              <p className="text-muted-foreground mb-1">{user.email}</p>
              {user.role === "admin" && (
                <Badge variant="secondary" className="mt-3">
                  Администратор
                </Badge>
              )}
            </div>
          </div>

          {/* Кнопки действий */}
          <div className="flex flex-wrap gap-2 md:ml-auto mt-4">
            {user.role === "admin" && (
              <Button
                variant="outline"
                onClick={handleAdminPanel}
                className="gap-2"
              >
                <Shield className="w-4 h-4" />
                Админ панель
              </Button>
            )}
            <Button
              variant="outline"
              onClick={handleChangePassword}
              className="gap-2"
            >
              <KeyRound className="w-4 h-4" />
              Сменить пароль
            </Button>
            <Button
              variant="destructive"
              onClick={handleLogout}
              className="gap-2"
            >
              <LogOut className="w-4 h-4" />
              Выйти
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
